import { useEffect, useState } from "react";
import { Bot, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export default function EscalationsPage() {
  const [escalations, setEscalations] = useState([]);

  const load = () => api.get("/admin/escalations").then((r) => setEscalations(r.data.escalations));
  useEffect(() => { load(); }, []);

  const resolve = async (id) => {
    try {
      await api.post(`/admin/escalations/${id}/resolve`);
      toast.success("Marked resolved — follow up with the customer by email");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div data-testid="admin-escalations-page">
      <div className="mb-6">
        <p className="eyebrow">AI support</p>
        <h1 className="font-heading text-2xl font-bold text-white">Chat escalations</h1>
        <p className="mt-1 text-xs text-slate-500">Conversations the AI assistant couldn't resolve automatically.</p>
      </div>
      <div className="space-y-4">
        {escalations.map((s) => (
          <div key={s.id} className="card-surface p-5" data-testid={`escalation-card-${s.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-400/10 text-amber-300"><Bot size={16} /></span>
                <div>
                  <p className="text-sm font-semibold text-white">{s.email || "Anonymous customer"}</p>
                  <p className="text-[11px] text-slate-500">Session {s.id} · {s.updated_at?.replace("T", " ").slice(0, 16)}</p>
                </div>
              </div>
              {s.resolved ? (
                <span className="flex items-center gap-1.5 text-xs font-semibold text-emerald-400"><CheckCircle2 size={14} /> Resolved</span>
              ) : (
                <button
                  data-testid={`escalation-resolve-${s.id}`}
                  onClick={() => resolve(s.id)}
                  className="rounded-full border border-emerald-400/40 px-4 py-1.5 text-xs font-semibold text-emerald-300 hover:bg-emerald-400/10"
                >
                  Mark resolved
                </button>
              )}
            </div>
            <div className="mt-4 max-h-56 space-y-2 overflow-y-auto rounded-xl bg-white/[0.03] p-4">
              {s.messages?.map((m) => (
                <div key={m.id} className={`text-xs ${m.role === "user" ? "text-amber-200" : "text-slate-400"}`}>
                  <span className="font-mono text-[10px] uppercase text-slate-600">{m.role === "user" ? "Customer" : "AI"}: </span>
                  {m.content}
                </div>
              ))}
            </div>
          </div>
        ))}
        {escalations.length === 0 && (
          <div className="card-surface p-12 text-center text-sm text-slate-500" data-testid="escalations-empty">
            No escalations — the AI is handling everything.
          </div>
        )}
      </div>
    </div>
  );
}
